module.exports = __webpack_public_path__ + "static/media/avatar-outline.2af00df1.svg";